function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconProjects({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14.0625C2.3175 14.0625 2.0625 13.8075 2.0625 13.5V5.25C2.0625 1.9425 3.0675 0.9375 6.375 0.9375H11.625C14.9325 0.9375 15.9375 1.9425 15.9375 5.25V12.75C15.9375 12.87 15.9375 12.9825 15.93 13.1025C15.9075 13.41 15.63 13.65 15.33 13.6275C15.0225 13.605 14.7825 13.335 14.805 13.0275C14.8125 12.9375 14.8125 12.84 14.8125 12.75V5.25C14.8125 2.5725 14.31 2.0625 11.625 2.0625H6.375C3.69 2.0625 3.1875 2.5725 3.1875 5.25V13.5C3.1875 13.8075 2.9325 14.0625 2.625 14.0625Z",
    fill: "#292D32",
    style: {
      fill: "#292D32",
      fill: "color(display-p3 0.1608 0.1765 0.1961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.0625H5.25C3.495 17.0625 2.0625 15.63 2.0625 13.875V13.3875C2.0625 11.895 3.2775 10.6875 4.7625 10.6875H15.375C15.6825 10.6875 15.9375 10.9425 15.9375 11.25V13.875C15.9375 15.63 14.505 17.0625 12.75 17.0625ZM4.7625 11.8125C3.8925 11.8125 3.1875 12.5175 3.1875 13.3875V13.875C3.1875 15.015 4.11 15.9375 5.25 15.9375H12.75C13.89 15.9375 14.8125 15.015 14.8125 13.875V11.8125H4.7625Z",
    fill: "#4A4A68",
    style: {
      fill: "#4A4A68",
      fill: "color(display-p3 0.2902 0.2902 0.4078)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.8125H6C5.6925 5.8125 5.4375 5.5575 5.4375 5.25C5.4375 4.9425 5.6925 4.6875 6 4.6875H12C12.3075 4.6875 12.5625 4.9425 12.5625 5.25C12.5625 5.5575 12.3075 5.8125 12 5.8125Z",
    fill: "#292D32",
    style: {
      fill: "#292D32",
      fill: "color(display-p3 0.1608 0.1765 0.1961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.4375H6C5.6925 8.4375 5.4375 8.1825 5.4375 7.875C5.4375 7.5675 5.6925 7.3125 6 7.3125H9.75C10.0575 7.3125 10.3125 7.5675 10.3125 7.875C10.3125 8.1825 10.0575 8.4375 9.75 8.4375Z",
    fill: "#292D32",
    style: {
      fill: "#292D32",
      fill: "color(display-p3 0.1608 0.1765 0.1961)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconProjects);
export default __webpack_public_path__ + "static/media/recon-projects.6a6e7b83cc6437704291a52ba5212e64.svg";
export { ForwardRef as ReactComponent };